export default "__VITE_ASSET__80c3e588__"